import { useMutation } from '@tanstack/react-query';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { SecurityType } from '@dealstack/shared/lib/generated';
import { updateSecurity as updateSecurityApi } from '@dealstack/frontend/shared/dataExchange/services/securities';

export const useUpdateSecurity = ({
	mipId,
	onSuccess,
}: {
	mipId: string;
	onSuccess: () => void;
}) => {
	const tCapManage = useTranslationCapManage();

	return useMutation({
		mutationFn: (data: {
			id: string;
			name: string;
			type: SecurityType;
			isSubjectToVesting: boolean;
			fairMarketValuePerUnit?: number | null;
			skipToast?: boolean;
		}) =>
			updateSecurityApi({
				id: data.id,
				name: data.name,
				type: data.type,
				fairMarketValuePerUnit: data.fairMarketValuePerUnit,
				securityProgrammeSettings: {
					mipId,
					isSubjectToVesting: data.isSubjectToVesting,
				},
			}),
		onSuccess: (_, variables) => {
			if (!variables.skipToast) {
				showToastV2({
					message: tCapManage('toasts.success.security_updated_successfully'),
				});
			}
			onSuccess();
		},
	});
};
